export default __webpack_public_path__ + "static/media/MBrassey-Logo.e86edc2a.png";